import { ref } from 'vue';
import { bindReferralCode as bindReferralCodeRequest, createToken, registerUser } from '@/api/auth';
import { CreateTokenRequest, User } from '@/types/auth';

const token = ref<string | null>(localStorage.getItem('token'));
const isTourist = ref(localStorage.getItem('tourist') === '1');

export const useAuth = () => {
  const getToken = (): string | null => {
    return token.value;
  };

  const setToken = (newToken: string): void => {
    token.value = newToken;
    localStorage.setItem('token', newToken);
  };

  const useTourist = (): void => {
    isTourist.value = true;
    localStorage.setItem('tourist', '1');
  };

  const quitTourist = (): void => {
    isTourist.value = false;
    localStorage.setItem('tourist', '0');
  };

  const isLogin = (): boolean => {
    return !!token.value;
  };

  const login = async (
    params: CreateTokenRequest
  ): Promise<{ success: boolean; isNewUser: boolean }> => {
    try {
      const response = await createToken(params);
      if (response.token?.accessToken) {
        setToken(response.token.accessToken);
        quitTourist();
        return { success: true, isNewUser: !!response.isNewUser };
      }
      return { success: false, isNewUser: false };
    } catch (error) {
      console.error('登录失败:', error);
      return { success: false, isNewUser: false };
    }
  };

  const register = async (params: {
    username: string;
    password: string;
    emailAddress?: string;
    phoneNumber?: string;
    verificationCode: string;
  }): Promise<boolean> => {
    try {
      const response = await registerUser(params);
      if (response.token?.accessToken) {
        setToken(response.token.accessToken);
        return true;
      }
      return false;
    } catch (error) {
      console.error('注册失败:', error);
      return false;
    }
  };

  const getUserInfo = async (): Promise<User> => {
    const response = await getUserInfo();
    return response;
  };

  const logout = () => {
    token.value = null;
    localStorage.removeItem('token');
  };

  const bindReferralCode = async (referralCode: string): Promise<boolean> => {
    try {
      const response = await bindReferralCodeRequest(referralCode);
      return !!response.success;
    } catch (error) {
      console.error('绑定邀请码失败:', error);
      return false;
    }
  };

  return {
    getToken,
    setToken,
    isLogin,
    login,
    register,
    getUserInfo,
    logout,
    bindReferralCode,
    useTourist,
    isTourist
  };
};
